import { Link } from "react-router-dom";

// --- Sub-component: SideNav ---
export const SideNav = () => {
  const sideNavContent = [
    {
      navName: "My Profile",
      navContent: "Personal information",
      navLink: "/dashboard/profile",
      icon: (
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
          <circle cx="12" cy="7" r="4"></circle>
        </svg>
      ),
    },
    {
      navName: "Security",
      navContent: "Password & security",
      navLink: "/dashboard/security",
      icon: (
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
        </svg>
      ),
    },
    {
      navName: "Plan Details",
      navContent: "Your investment plans",
      navLink: "/dashboard/aboutplans",
      icon: (
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect>
          <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path>
        </svg>
      ),
    },
    {
      navName: "Referral Program",
      navContent: "Invite friends & earn",
      navLink: "/dashboard/refer",
      icon: (
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M17 21v-2a4 4 0 0 0-4-4H5c-2.2 0-4 1.8-4 4v2"></path>
          <circle cx="9" cy="7" r="4"></circle>
          <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
          <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
        </svg>
      ),
    },
    {
      navName: "About Us",
      navContent: "About Africa's Trusted Digital Platform",
      navLink: "/dashboard/aboutus",
      icon: (
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <circle cx="12" cy="12" r="10"></circle>
          <line x1="12" y1="16" x2="12" y2="12"></line>
          <line x1="12" y1="8" x2="12.01" y2="8"></line>
        </svg>
      ),
    },
  ];

  return (
    <div className="bg-white rounded-[1.5rem] shadow-[0_4px_20px_rgb(0,0,0,0.03)] border border-gray-50 flex flex-col overflow-hidden mb-8">
      {sideNavContent.map(({ navName, navContent, icon, navLink }, index) => (
        <Link
          key={index}
          to={navLink}
          className={`group relative p-4 flex items-center justify-between hover:bg-blue-50/50 transition-colors active:bg-blue-50 ${
            index !== sideNavContent.length - 1 ? "border-b border-gray-50" : ""
          }`}
        >
          <div className="flex items-center gap-4">
            <div className="w-10 h-10 rounded-[0.8rem] bg-[#f8faff] border border-[#dce5fc] flex items-center justify-center text-[#1a4bdf] group-hover:bg-[#1a4bdf] group-hover:text-white transition-colors shadow-sm">
              {icon}
            </div>
            <div className="flex flex-col">
              <h4 className="text-[15px] font-bold text-slate-900 group-hover:text-[#1a4bdf] transition-colors">
                {navName}
              </h4>
              <p className="text-[11px] text-slate-500 font-medium">
                {navContent}
              </p>
            </div>
          </div>
          <div className="text-slate-300 group-hover:text-[#1a4bdf] group-hover:translate-x-1 transition-all">
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <polyline points="9 18 15 12 9 6"></polyline>
            </svg>
          </div>
        </Link>
      ))}
    </div>
  );
};
